import React from 'react'

interface SlideCaptionRowProps<T> {
  className: string;
  items: T[];
  activeIndex: number;
  renderItem: (item: T) => React.ReactNode;
}

function SlideCaptionRow<T>({ className, items, activeIndex, renderItem }: SlideCaptionRowProps<T>) {
  return (
    <div className={`embla__slide__caption ${className}`}>
      {items.map((item, index) => {
        const isCurrent = index === activeIndex

        return (
          <div
            key={index}
            className="embla__slide__caption__cell"
            style={{ visibility: isCurrent ? 'visible' : 'hidden' }}
            aria-hidden={!isCurrent}
          >
            {renderItem(item)}
          </div>
        )
      })}
    </div>
  )
}

export default SlideCaptionRow